import { isEmbeddedInCrmIframe } from './is-embedded-in-crm-iframe';

/** Class on `<html>` that switches Studio into the CRM iframe scrollport. */
export const CRM_EMBED_SCROLLPORT_CLASS = 'enrollio-crm-embed';

/**
 * ENR-4098: when Studio runs inside the CRM marketplace iframe, lock the
 * document to the iframe box and let `.enrollio-app-root` own vertical
 * scrolling. Users were grabbing the CRM outer scrollbar (limited travel
 * after HighLevel LevelUp) and could only reach half the Studio UI.
 */
export function applyCrmEmbedScrollportClass(
  doc: Document = document,
  win: Pick<Window, 'self' | 'top'> = window,
): void {
  if (!isEmbeddedInCrmIframe(win)) {
    doc.documentElement.classList.remove(CRM_EMBED_SCROLLPORT_CLASS);
    return;
  }
  doc.documentElement.classList.add(CRM_EMBED_SCROLLPORT_CLASS);
}
